module.exports = __webpack_public_path__ + "static/img/Tech_02.42a4c504.png";